import { CommonModule, Location } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';

import { HeaderComponent } from '../../../../shared/components/header/header.component';
import { TabsScrollDirective } from '../../../../shared/directives/tabs-scroll.directive';
import { FuncionalidadeEnum } from '../../../../shared/enums/usuario/funcionalidade.enum';
import { ModuloEnum } from '../../../../shared/enums/usuario/modulo.enum';
import { AbaFechamentosComponent } from './tabs/aba-fechamentos/aba-fechamentos.component';
import { AbaVendasComponent } from './tabs/aba-vendas/aba-vendas.component';

type AbaAtiva = 'vendas' | 'fechamentos';

@Component({
  selector: 'app-dados-integracao-scanntech',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatTabsModule,
    TabsScrollDirective,
    MatTooltipModule,
    HeaderComponent,
    AbaVendasComponent,
    AbaFechamentosComponent,
  ],
  templateUrl: './dados-integracao-scanntech.component.html',
  styleUrl: './dados-integracao-scanntech.component.css',
})
export class DadosIntegracaoScanntechComponent {
  public moduloEnum: ModuloEnum = ModuloEnum.Integracao;
  public funcionalidadeEnum: FuncionalidadeEnum = FuncionalidadeEnum.Integracao_ResulthScanntech;

  public abaAtivaIndex: number = 0;

  @ViewChild(AbaVendasComponent)
  private abaVendasRef?: AbaVendasComponent;

  @ViewChild(AbaFechamentosComponent)
  private abaFechamentosRef?: AbaFechamentosComponent;

  constructor(private location: Location) {}

  public voltar(): void {
    this.location.back();
  }

  public onAbaChange(index: number): void {
    this.abaAtivaIndex = index;
  }

  public get abaAtiva(): AbaAtiva {
    return this.abaAtivaIndex === 1 ? 'fechamentos' : 'vendas';
  }

  public get abaVendasAtiva(): boolean {
    return this.abaAtiva === 'vendas';
  }

  public get abaFechamentosAtiva(): boolean {
    return this.abaAtiva === 'fechamentos';
  }

  public get quantidadeSelecionadaAbaAtiva(): number {
    return this.abaVendasAtiva
      ? this.abaVendasRef?.quantidadeSelecionada ?? 0
      : this.abaFechamentosRef?.quantidadeSelecionada ?? 0;
  }

  public get quantidadeSelecionadaParaHabilitarAbaAtiva(): number {
    return this.abaVendasAtiva
      ? this.abaVendasRef?.quantidadeSelecionadaParaHabilitar ?? 0
      : this.abaFechamentosRef?.quantidadeSelecionadaParaHabilitar ?? 0;
  }

  public get quantidadeSelecionadaParaDesabilitarAbaAtiva(): number {
    return this.abaVendasAtiva
      ? this.abaVendasRef?.quantidadeSelecionadaParaDesabilitar ?? 0
      : this.abaFechamentosRef?.quantidadeSelecionadaParaDesabilitar ?? 0;
  }

  public get hintHabilitarReprocessamento(): string {
    if (this.quantidadeSelecionadaAbaAtiva === 0) return 'Selecione ao menos um item da lista.';
    return 'Apenas itens inválidos ou pendentes que ainda não estão habilitados podem ser habilitados para reprocessamento.';
  }

  public get hintDesabilitarReprocessamento(): string {
    if (this.quantidadeSelecionadaAbaAtiva === 0) return 'Selecione ao menos um item da lista.';
    return 'Apenas itens já habilitados para reprocessamento podem ser desabilitados.';
  }

  public marcarSelecionadosReprocessamento(): void {
    if (this.abaVendasAtiva) {
      this.abaVendasRef?.marcarSelecionadosReprocessamento();
      return;
    }

    this.abaFechamentosRef?.marcarSelecionadosReprocessamento();
  }

  public desmarcarSelecionadosReprocessamento(): void {
    if (this.abaVendasAtiva) {
      this.abaVendasRef?.desmarcarSelecionadosReprocessamento();
      return;
    }

    this.abaFechamentosRef?.desmarcarSelecionadosReprocessamento();
  }
}
